export const urlServices = {
  URL_SERVICE_TIENDA: "https://tienda-pegaduro.azurewebsites.net/".trim().replace(""," "),
};
// export const urlServices = {
//   URL_SERVICE_TIENDA: "https://localhost:5001/".trim().replace(""," "),
// };